var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralFan2DP = function SvgDAhuGeneralFan2DP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "426,359 386,359 386,333 388,333 388,357 424,357 424,333 426,333"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 358,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,348c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S400.5,348,406,348 M406,347c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S412.1,347,406,347L406,347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M403.5,354.7h1l2.2,5.7h-5.5L403.5,354.7z M402.5,359.6h2.9l-1.4-3.7L402.5,359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8,358.3c0,0.6-0.1,1.2-0.5,1.6c-0.3,0.4-0.7,0.6-1.2,0.6c-0.5,0-0.8-0.1-1.1-0.5v2h-1v-5.9h0.9l0,0.4 c0.3-0.3,0.7-0.5,1.1-0.5c0.5,0,0.9,0.2,1.2,0.6S410.8,357.5,410.8,358.3L410.8,358.3L410.8,358.3z M409.9,358.2 c0-0.4-0.1-0.8-0.2-1s-0.4-0.4-0.7-0.4c-0.4,0-0.7,0.2-0.8,0.5v1.9c0.2,0.3,0.5,0.5,0.8,0.5c0.3,0,0.5-0.1,0.7-0.4 C409.8,359.1,409.9,358.7,409.9,358.2L409.9,358.2z"
  })))))));
};
export default SvgDAhuGeneralFan2DP;